import React, { useEffect, useLayoutEffect, useRef } from "react";
import { Form } from "react-bootstrap";

// The native picker owns its draft. Expensive canvas/React updates wait until
// the user pauses, closes the picker, or moves focus to another control.
export default function ShareColorControl({ value, onChange, ...props }) {
  const inputRef = useRef(null);
  const callbackRef = useRef(onChange);
  const committedRef = useRef(value);
  callbackRef.current = onChange;

  useLayoutEffect(() => {
    committedRef.current = value;
    if (inputRef.current) inputRef.current.value = value;
  }, [value]);

  useEffect(() => {
    const input = inputRef.current;
    let timer;
    const commit = () => {
      clearTimeout(timer);
      if (input.value === committedRef.current) return;
      committedRef.current = input.value;
      callbackRef.current({ target: { value: input.value } });
    };
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(commit, 200);
    };
    input.addEventListener("input", schedule);
    input.addEventListener("change", schedule);
    input.addEventListener("blur", commit);
    return () => {
      clearTimeout(timer);
      input.removeEventListener("input", schedule);
      input.removeEventListener("change", schedule);
      input.removeEventListener("blur", commit);
    };
  }, []);

  return <Form.Control {...props} ref={inputRef} type="color" defaultValue={value} />;
}
